/** Three-letter language pill (EN / PT / DE). When `supported` is false
 *  the pill is struck through and dim; when `active` it inverts to the
 *  ink color. Matches design-handoff/project/components.jsx:LangPill.
 */
export function LangPill({
  id,
  supported = true,
  active = false,
  onClick,
}: {
  id: string;
  supported?: boolean;
  active?: boolean;
  onClick?: () => void;
}) {
  const interactive = !!onClick;
  const sharedStyle: React.CSSProperties = {
    display: "inline-block",
    fontFamily: "var(--mono)",
    fontSize: 10.5,
    letterSpacing: "0.06em",
    padding: "2px 7px",
    borderRadius: 4,
    border: `1px solid ${active ? "var(--ink)" : "var(--rule)"}`,
    background: active
      ? "var(--ink)"
      : supported
        ? "var(--card)"
        : "transparent",
    color: active
      ? "var(--paper)"
      : supported
        ? "var(--ink-2)"
        : "var(--ink-4)",
    cursor: interactive && supported ? "pointer" : "default",
    textDecoration: supported ? "none" : "line-through",
  };
  if (interactive) {
    return (
      <button
        type="button"
        onClick={onClick}
        disabled={!supported}
        style={sharedStyle}
      >
        {id}
      </button>
    );
  }
  return <span style={sharedStyle}>{id}</span>;
}
